import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Row, Col, Table, Card, Modal, Select, Button, Input, Switch, Spin, Icon, Badge } from "antd";
import SalesAnalysisTradeYear from "./sales-analysis-trade-year";
import SupplyChainStats from "./supply-chain-stats";
import SupplyChainProposedLimit from "./supply-chain-proposed-limit";
import AssociatesAddTable from "./associates-add-table";
import CompanyProfileForm from "forms/company-profile-form";
import CaseDetailsForm from "forms/case-detail-form";
import SpocDetailForm from "forms/company-spoc-details-form";
import AddressCard from "./address-card";
import BankAccountAddList from "./bank-account-add-list";
import ApplicantVerificationTable from "./applicant-verification-table";
import ApplicantParameterCheckerModal from "./applicant-parameter-checker-modal";
import { OrderedMap, Map, List } from "immutable";
import {
    fetchCaseSupplyChainDetails,
    fetchCaseSupplyChainFinancials,
    updateCaseDetail,
    updateCaseSupplyChainDetails,
    updateCompanyProfile,
    updateCompanyAssociates,
    updateCompanyAddresses,
    updateCompanyAddress,
    updateCompanyBankAccounts,
    addCaseAssociates,
    deleteCaseAssociates,
    fetchAssociatesVerificationList,
    fetchCompanyDocuments,
    fetchCaseDocuments,
    addCaseBankAccounts,
    deleteCaseBankAccounts,
    createCibilRequest,
    fetchCaseAssociates,
    updateCaseAssociateStatus,
    fetchCompanyProfile,
    addCaseCompanyAssociates,
    fetchCompanyAssociatesV2,
    fetchCaseDetailFields
} from "store/actions";
import { formatCurrency } from "utilities";
import { STATE_STATUS } from "constants";
import { APPLICANT_TYPES } from "constants/enums";
import { CaseDetailRecord } from "records/case-record";
import { CompanyService } from "services/index";
import { RCU_VERIFICATION_STATUS_TYPES } from "../../constants/enums";
import { message } from "../../../node_modules/antd/lib/index";
import EntityVerificationTable from "./entity-detail-verification";
import moment from "moment";
import AssociatesNewForm from "./associate-new-form";
import CaseBureauDetails from "./case-bureau-details";

const TALLY_OUTSTANDING_COLS = new OrderedMap({
    "seller.name": {
        title: "Seller Name",
        dataIndex: "seller.name",
        key: "seller.name"
    },
    last_sync_date: {
        title: "Last Sync Date",
        dataIndex: "last_sync_date",
        key: "last_sync_date"
    },
    closing_balance: {
        title: "Closing Balance",
        dataIndex: "closing_balance",
        key: "closing_balance"
    }
});


const CREDIT_APPRAISAL_STAGE_IDS = [7];

/**
 * Case Summary Tab
 * Handles Account, Address, Associate Update and Add
 */
class CaseSummary extends React.Component {
    state = {
        showApplicantParameterModal: false,
        gstin_address_fetch: false,
        gstin_address: null,
        showApplicantModal: false,
        associates: new Map({}),
        caseAssociates: null,
        showVerificationModal: false,
        verificationData: null,
        showOtpConfirmation: false,
        otpValue: null,
        showBankAccountApplicableModal: false,
        caseBankAccounts: null,
        applicant_id: null,
        bank_account_id: null,
        getRegisteredNachDate: null,
        loading: false,
        deleteAssociate: false,
        modalToggleData : List()
    };
    /**
     * Handles supply chain data on component mount, expects caseId to be
     * available in the props beforehand
     */
    componentDidMount() {
        if (this.props.supplyChainStatus === STATE_STATUS.UNFETCHED) {
            this.props.fetchCaseSupplyChainDetails(this.props.caseId);
        }
        this.handleFilesFetch();
        this.handleDocumentsFetch();
        this.getRegisteredNachDateFn();
        this.props.fetchAssociatesVerificationList(this.props.companyId);
        if (this.props.caseDetailFieldsStatus === STATE_STATUS.UNFETCHED) {
            this.props.fetchCaseDetailFields(this.props.caseId);
        }
        // this.props.fetchCompanyAssociatesV2(this.props.caseId)
    }
    /**
     * Handles supply chain data fetch when the component updates, and company id was
     * not present during the component mount phase
     */
    componentDidUpdate(prevProps) {
        if (this.props.supplyChainStatus === STATE_STATUS.UNFETCHED) {
            this.props.fetchCaseSupplyChainDetails(this.props.caseId);
        }
        if(
            !this.state.associates.size && 
            this.props.company && 
            this.props.company.associates && 
            this.props.company.associates.size
        ) {
            this.setState({
                associates: this.props.company && this.props.company.associates 
            });
        }
        if(this.props.caseAssociatesStatus === STATE_STATUS.FETCHED && (!this.state.caseAssociates || (prevProps.caseAssociates !== this.props.caseAssociates))) {
            this.setState({
                caseAssociates: this.props.caseAssociates,
                modalToggleData: this.props.caseAssociates.map(_ => ({
                    company_associate: { id: _.company_associate.id },
                    is_main_borrower: _.is_main_borrower,
                    is_authorized_signatory: _.is_authorized_signatory,
                    type: _.type
                }))
            });
        }

        if(this.props.caseBankAccountsStatus === STATE_STATUS.FETCHED && (!this.state.caseBankAccounts || (prevProps.caseBankAccounts !== this.props.caseBankAccounts))) {
            this.setState({
                caseBankAccounts: this.props.caseBankAccounts
            });
        }

        this.handleFilesFetch();
        this.handleDocumentsFetch();
    }

    refreshVerificationList = () => {
        this.props.fetchAssociatesVerificationList(this.props.companyId);
    }

    async handleFilesFetch() {
        if (
            this.props.companyId &&
            (!this.props.files ||
                this.props.files.get("status") === STATE_STATUS.UNFETCHED)
        ) {
            this.props.fetchCompanyDocuments(
                this.props.caseId,
                this.props.companyId
            );
        }
    }

    async handleDocumentsFetch() {
        if (
            this.props.caseId &&
            (!this.props.documents ||
                this.props.documents.get("status") === STATE_STATUS.UNFETCHED)
        ) {
            this.props.fetchCaseDocuments(
                this.props.caseId,
                this.props.companyId
            );
        }
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.supplyChainStatus === STATE_STATUS.UNFETCHED) {
            nextProps.fetchCaseSupplyChainDetails(nextProps.caseId);
        }
    }
    onProposedLimitChange = value =>
        this.props.updateCaseDetail(
            this.props.caseId,
            this.props.caseDetail.set("proposed_limit", value)
        );

    onSalesDisplayChange = (displayYear, displayCurrency) => {
        this.props.updateCaseDetail(
            this.props.caseId,
            this.props.caseDetail.set("sales_analysis_display_type", Number(displayYear)).set("sales_analysis_display_currency", Number(displayCurrency))
        );
    }

    updateBasicCompanyProfile = (values) => {
        this.props.updateCompanyProfile(this.props.companyId, values);
    }

    renderSupplyChainView(permissionContext) {
        if(permissionContext.find((_, k) => k === "case_details_supply_chain_view")) {
            return(<Col span={24}>
                <Row>
                    <Col span={15} className={"p-10"}>
                        <SupplyChainStats
                            data={
                                this.props.supplyChain &&
                                    this.props.supplyChain.statsList
                            }
                            isUserAllowedToEdit={this.props.isUserAllowedToEdit}
                        />
                    </Col>
                    <Col span={9} className={"p-10"}>
                        <SupplyChainProposedLimit
                            data={
                                this.props.supplyChain &&
                                    this.props.supplyChain.supplyChainLimitList
                            }
                            proposedLimit={
                                this.props.caseDetail &&
                                    this.props.caseDetail.get("proposed_limit")
                            }
                            update={this.onProposedLimitChange}
                            isUserAllowedToEdit={this.props.isUserAllowedToEdit}
                            recreditViewOnlyPermission={this.props.recreditViewOnlyPermission}
                        />
                    </Col>
                </Row>
            </Col>);
        }
        return null;
    }

    renderProfileForm(permissionContext) {
        if(permissionContext.find((_, k) => k === "case_details_company_profile_view")) {
            return(
                <Col span={24} className={"p-10"}>
                    <div className={"d-flex"}>
                        <div className={"fb-50 p-5"}>
                            <CompanyProfileForm 
                                values={this.props.company && this.props.company.getCompanyProfile()}
                                companyProfile={this.props.company}
                                updateCompanyProfile={this.updateBasicCompanyProfile}
                            />
                        </div>
                        <div className={"fb-50 p-5"}>
                            <CaseDetailsForm
                                caseDetail={this.props.caseDetail}
                                caseId={this.props.caseId}
                                updateCaseDetail={this.props.updateCaseDetail}
                                values={this.props.caseDetail && this.props.caseDetail.getCaseDetailFormValues()}
                            />
                        </div>
                    </div>
                </Col>
            );
        }
        return null;
    }

    renderSalesAnalysis(permissionContext) {
        if(permissionContext.find((_, k) => k === "case_details_supply_chain_view")) {
            return(<Col span={24} className={"p-10"}>
                <SalesAnalysisTradeYear
                    displayYear={this.props.caseDetail &&
                            String(this.props.caseDetail.get("sales_analysis_display_type"))}
                    displayCurrency={this.props.caseDetail &&
                            String(this.props.caseDetail.get("sales_analysis_display_currency"))}
                    isUserAllowedToEdit={this.props.isUserAllowedToEdit}
                    onSalesDisplayChange={this.onSalesDisplayChange}
                    permissionContext={permissionContext}
                    financials={this.props.financials}
                    financialsStatus={this.props.financialsStatus}
                    fetch={this.props.fetchCaseSupplyChainFinancials}
                    caseId={this.props.caseId}
                />
            </Col>);
        }
        return null;
    }

    renderCaseTallyOutstanding(permissionContext) {
        if(
            permissionContext.find((_, k) => k === "tally_outstanding_details") &&
            this.props.caseDetail && this.props.caseDetail.tally_outstanding &&
            this.props.caseDetail.tally_outstanding.length
        ) {
            const tallyOutstandings = this.props.caseDetail && this.props.caseDetail.getTallyOutStandingDetails();
            // const totalOutstanding = tallyOutstandings.reduce((agg, v) => agg + +v.closing_balance, 0);
            return (
                <Card title={"Tally Outstanding"} className={"padless-card"} 
                    // extra={
                    //     <span>Total Outstanding : {formatCurrency(totalOutstanding, null)}</span>
                    // }
                >
                    <Table 
                        columns={TALLY_OUTSTANDING_COLS.toList().toArray()}
                        dataSource={tallyOutstandings.map(_ => ({
                            ..._,
                            closing_balance: formatCurrency(_.closing_balance, true)
                        }))}
                        pagination={false}
                    />
                </Card>
            );
        }
        return null;
    }

    getRegisteredNachDateFn = () => {
        CompanyService.getNachRegisteredDate(this.props.caseId).then(res=>{
            this.setState({getRegisteredNachDate: (res.data)});
        });
    }

    renderSpocForm(permissionContext) {
        const {
            companyId,
            companyStatus,
            company,
            updateCompanyAddress
        } = this.props;
        if(permissionContext.find((_, k) => k === "case_details_company_profile_view")) {
            return(<Row>
                <Col span={24}>
                    <SpocDetailForm
                        values={this.props.company && this.props.company.associates}
                        updateAssociates={this.props.updateCompanyAssociates}
                        companyId={this.props.companyId}
                    />
                </Col>
                <Col span={12} className={"p-10"}>
                    <AddressCard
                        companyId={companyId}
                        title={"Registered Address"}
                        type={"Registered"}
                        address={company.registered_address}
                        optionalAddress={this.state.gstin_address}
                        optionalAddressLabel={"Select as per GSTIN"}
                        status={
                            companyStatus &&
                                    companyStatus.get("addressesStatus")
                        }
                        isUserAllowedToEdit={this.props.isUserAllowedToEdit}
                        update={updateCompanyAddress}
                        recreditViewOnlyPermission={this.props.recreditViewOnlyPermission}
                    />
                </Col>
            </Row>);
        }
        return null;
    }

    openCaseApplicantModal = () => {
        this.setState({
            showApplicantModal: true
        });
    }

    updateCaseApplicants = () => {
        let addresses = this.props.company && this.props.company.addresses.filter(_ => _.associate);
        this.setState({
            showApplicantModal: false
        }, () => {
                let associatesAdded = this.state.modalToggleData && this.state.modalToggleData.filter(_ => _.company_associate && _.company_associate.id !== undefined).map(_ => ({
                    id: _.company_associate.id,
                    type: _.type,
                    is_main_borrower: _.is_main_borrower,
                    is_authorized_signatory: _.is_authorized_signatory
                }));
            // let associatesAdded = this.state.caseAssociates && this.state.caseAssociates.map(_ => ({id: _.company_associate.id, type: _.type, is_main_borrower: _.is_main_borrower,is_authorized_signatory: _.is_authorized_signatory}));
            // let associatesDeleted = this.state.caseAssociates && this.state.caseAssociates.filter(_ => ![1,2].includes(_.type)).map(_ => ({id: _.company_associate.id, type: _.type}));
            this.props.addCaseCompanyAssociates(this.props.caseId, associatesAdded, this.props.companyId, this.state.associates && this.state.associates.toList().toArray(), addresses && addresses.toList().toArray());
            // this.props.deleteCaseAssociates(this.props.caseId, associatesDeleted);
            // this.props.updateCompanyAssociates(
            //     this.props.companyId,
            //     this.state.associates && this.state.associates.toList().toArray(),
            //     addresses && addresses.toList().toArray()
            // );
        });
    }

    updateCaseBankAccounts = () => {
        this.setState({
            showBankAccountApplicableModal: false
        }, () => {
            let accountsAdded = this.state.caseBankAccounts && this.state.caseBankAccounts.map(_ => ({id: _.company_bank_account, is_applicable: _.is_applicable}));
            this.props.addCaseBankAccounts(this.props.caseId, accountsAdded);
        });
    }

    closeApplicantModal = () => {
        this.setState({
            showApplicantModal: false
        });
    }

    onapplicant_idType = (id, val) => {
        this.setState({
            modalToggleData: this.state.modalToggleData.map(item => ({
                ...item,
                type:
                    item.company_associate.id === id ? val : item.type,
            }))
        })
        // let associates = this.state.caseAssociates;
        // if(associates?.length) {
        //     let associate = associates.findIndex(_ => _.company_associate && _.company_associate.id == id);
        //     if((associate || associate == 0) && associate !== -1) {
        //         associates[associate].type = val;
        //     } else {
        //         associates = [
        //             ...associates,
        //             {
        //                 company_associate: {
        //                     id
        //                 },
        //                 type: val
        //             }
        //         ];
        //     }
        // } else {
        //     associates = [
        //         {
        //             company_associate: {
        //                 id
        //             },
        //             type: val
        //         }
        //     ];
        // }
        // this.setState({
        //     caseAssociates: associates
        // });
    }

    onChangeIsMainBrrower = (id, val) => {
         this.setState({
            modalToggleData: this.state.modalToggleData.map(item => ({
                ...item,
                is_main_borrower:
                    item.company_associate.id === id ? val : item.is_main_borrower,
            }))
        })
        // let associates = this.state.caseAssociates;
        // if(associates.length) {
        //     let associate = associates.findIndex(_ => _.company_associate && _.company_associate.id == id);
        //     if((associate || associate == 0) && associate !== -1) {
        //         associates[associate].is_main_borrower = val;
        //     } else {
        //         associates = [
        //             ...associates,
        //             {
        //                 company_associate: {
        //                     id
        //                 },
        //                 is_main_borrower: val
        //             }
        //         ];
        //     }
        // } else {
        //     associates = [
        //         {
        //             company_associate: {
        //                 id
        //             },
        //             is_main_borrower: val
        //         }
        //     ];
        // }
        // this.setState({
        //     caseAssociates: associates
        // });
    }

    onChangeisauthorizedsignatory = (id, val) => {
        // let associates = this.state.caseAssociates;
        // let modalToggleData = this.state.modalToggleData;
        // console.log('associatesssss ', associates, 'id', id, 'val', val)
        // if (val === true) {
        //     const alreadyAuthorized = associates.find(
        //         _ => _.is_authorized_signatory === true && _.company_associate?.id !== id
        //     );

        //     if (alreadyAuthorized) {
        //         message.error("Only 1 applicant can be authorized, please make changes.");
        //         return;
        //     }
        // }
        
            // console.log("company_associate", id, '1231231', this.state.modalToggleData.toJS())
        this.setState({
            modalToggleData: this.state.modalToggleData.map(item => ({
                ...item,
                is_authorized_signatory:
                    item.company_associate.id === id ? val : false,
            }))
        })
        
        // if (associates.length) {
        //     let associateIndex = associates.findIndex(_ => _.company_associate && _.company_associate.id == id);
        //     if ((associateIndex || associateIndex === 0) && associateIndex !== -1) {
        //         associates[associateIndex].is_authorized_signatory = val;
        //     } else {
        //         associates = [
        //             ...associates,
        //             {
        //                 company_associate: {
        //                     id
        //                 },
        //                 is_authorized_signatory: val
        //             }
        //         ];
        //     }
        // } else {
        //     associates = [
        //         {
        //             company_associate: {
        //                 id
        //             },
        //             is_authorized_signatory: val
        //         }
        //     ];
        // }
        // this.setState({
        //     caseAssociates: associates
        // });
    };



    onSelectIsBankAccountApplicable = (id, val) => {
        let bankAccounts = this.state.caseBankAccounts;
        if(bankAccounts.length) {
            let account = bankAccounts.findIndex(_ => _.company_bank_account == id);
            if(account && account !== -1) {
                bankAccounts[account].type = val;
            } else {
                bankAccounts = [
                    ...bankAccounts,
                    {
                        company_bank_account: id,
                        is_applicable: val
                    }
                ];
            }
        } else {
            bankAccounts = [
                {
                    company_bank_account: id,
                    is_applicable: val
                }
            ];
        }
        this.setState({
            caseBankAccounts: bankAccounts
        });
    }

    getCaseAssociateDefaultValue = (_) => {
        if(this.state.modalToggleData && (this.state.modalToggleData.length || this.state.modalToggleData.size)) {
            let associate = this.state.modalToggleData.find(val => _.id == (val.company_associate && val.company_associate.id));
            if(associate) {
                return associate.type;
            }
            return null;
        }
        return null;
    }

    requestCibil = (val) => {
        this.props.createCibilRequest(this.props.caseId, val);
    }

    is_cibil_requested = (_) => {
        if(this.state.caseAssociates && (this.state.caseAssociates.length || this.state.caseAssociates.size)) {
            let associate = this.state.caseAssociates.find(val => _.id == (val.company_associate && val.company_associate.id));
            if(associate) {
                return associate.is_cibil_requested;
            }
            return null;
        }
        return null;
    }


    getCaseAssociatesTable = () => {
        const { company } = this.props;
        return (
            <React.Fragment>
                <div className={"w-100"}>
                    {company.associates && company.associates.map((_, k) => (
                        <div key={k} className={"mt-5 p-5 mb-5 d-flex justify-content-space-between"}>
                            <div className={"d-flex flex-column"}>
                                <span style={{fontWeight: "600"}}>
                                    {`${_.first_name || ""} ${_.last_name || ""}`}
                                </span>
                                <span>
                                    {_.phone || ""}
                                </span>
                                <span>
                                    {_.email || ""}
                                </span>
                            </div>
                            <div className={"d-flex flex-column"}>
                                <span className={"mb-5"}>
                                    {
                                        this.getCaseAssociateDefaultValue(_) ?
                                            APPLICANT_TYPES.findKey(__ => __ == this.getCaseAssociateDefaultValue(_))
                                            : "--"
                                    }
                                </span>
                                {_ && this.is_cibil_requested(_) ? (
                                    <Button type={"primary"} size={"small"} disabled={this.props.recreditViewOnlyPermission} onClick={this.requestCibil.bind(null, _.id)}>
                                        {"CIBIL Requested - Resend CIBIL Request"}
                                    </Button>
                                ) : (
                                    <Button type={"primary"} size={"small"} disabled={this.props.recreditViewOnlyPermission} onClick={this.requestCibil.bind(null, _.id)}>
                                        {"Request CIBIL"}
                                    </Button>
                                )}
                            </div>
                        </div>
                    )).toList().toArray()}
                </div>
            </React.Fragment>
        );
    }

    closeVerficationModal = () => {
        this.setState({
            showVerificationModal: false,
            verificationData: null,
            showOtpConfirmation: false
        });
    }

    askForOtp = () => {
        let verificationData = this.state.verificationData;
        let requestId = null;
        if(this.state.selectedVerficationType == "email") {
            requestId = this.state.verificationData && this.state.verificationData.email && this.state.verificationData.email.request_id;
            verificationData = {
                ...verificationData,
                email: {
                    ...verificationData.email,
                    verification_status: RCU_VERIFICATION_STATUS_TYPES.INITIATED
                }
            };
        } else {
            requestId = this.state.verificationData && this.state.verificationData.phone && this.state.verificationData.phone.request_id;
            verificationData = {
                ...verificationData,
                phone: {
                    ...verificationData.phone,
                    verification_status: RCU_VERIFICATION_STATUS_TYPES.INITIATED
                }
            };
        }
        CompanyService.initiateValidation(requestId).then(() => {
            this.setState({
                showOtpConfirmation: true,
                verificationData
            });
        });
    }

    confirmViaOtp = () => {
        let requestId = null;
        if(this.state.selectedVerficationType == "email") {
            requestId = this.state.verificationData && this.state.verificationData.email && this.state.verificationData.email.request_id;
        } else {
            requestId = this.state.verificationData && this.state.verificationData.phone && this.state.verificationData.phone.request_id;
        }
        CompanyService.confirmPhoneEmailValidation(requestId, { verification_response: this.state.otpValue }).then(() => {
            this.closeVerficationModal();
            this.props.fetchAssociatesVerificationList(this.props.companyId);
        });
    }

    verifyPanAdhaar = () => {
        let requestId = null;
        if(this.state.selectedVerficationType == "pan") {
            requestId = this.state.verificationData && this.state.verificationData.pan && this.state.verificationData.pan.request_id;
        } else if(this.state.selectedVerficationType == "adhaar") {
            requestId = this.state.verificationData && this.state.verificationData.aadhar && this.state.verificationData.aadhar.request_id;
        } else if(this.state.selectedVerficationType == "phone") {
            requestId = this.state.verificationData && this.state.verificationData.phone && this.state.verificationData.phone.request_id;
        } else if(this.state.selectedVerficationType == "email") {
            requestId = this.state.verificationData && this.state.verificationData.email && this.state.verificationData.email.request_id;
        } else if(this.state.selectedVerficationType == "company_pan") {
            requestId = this.state.verificationData && this.state.verificationData.company_pan && this.state.verificationData.company_pan.request_id;
        }

        let document = null;
        let selectedAssociate = this.state.verificationData && this.state.verificationData.id;
        let documents  = this.props.documents && this.props.documents.get("data").map(_ => _.get("data"));
        let data = {
            request_id: requestId,
            name: this.state.verificationData && this.state.verificationData.name
        };
        if(this.state.selectedVerficationType == "pan") {
            document = documents.find(_ => Number(_.associate) == Number(selectedAssociate) && [7, 12].includes(Number(_.document)));
            data["number"] = this.state.verificationData && this.state.verificationData.pan_no;
        }
        if(this.state.selectedVerficationType == "adhaar") {
            document = documents.find(_ => Number(_.associate) == Number(selectedAssociate) && [8, 13].includes(Number(_.document)));
            data["number"] = this.state.verificationData && this.state.verificationData.aadhar_no;
        }
        if(this.state.selectedVerficationType == "company_pan") {
            data["number"] = this.state.verificationData && this.state.verificationData.pan_no;
            data["document_master_id"] = this.state.verificationData && this.state.verificationData.document.id;
        }else{
            data["document_master_id"] = document && document.file && document.file.id;
        }
        CompanyService.verifyPanAadhaar(data).then(() => {
            this.closeVerficationModal();
            this.props.fetchAssociatesVerificationList(this.props.companyId);
        });
    }

    fetchAssociateList = (id) => {
        CompanyService.retryVerification(id).then(() => {
            this.props.fetchAssociatesVerificationList(this.props.companyId);
        });
    }

    triggerOtpModal = () => {
        return (
            <React.Fragment>
                <h4 className={"mt-10"}>
                    Do you want to send OTP for verification email/phone?
                </h4>
                <div className="mt-10 d-flex flex-row align-items-center">
                    <Button type={"primary"} onClick={this.askForOtp} disabled={this.props.recreditViewOnlyPermission}>
                        Send OTP
                    </Button>
                    <Button className={"ml-10"} onClick={this.closeVerficationModal}>
                        Cancel
                    </Button>
                </div>
            </React.Fragment>
        );
    }

    onchangeOtpField = (e) => {
        this.setState({
            otpValue: e.target.value
        });
    } 

    sendOtpConfirmationModal = () => {
        return(
            <React.Fragment>
                <h4 className={"mt-10"}>
                    Enter OTP sent to {this.state.selectedVerficationType == "phone" ? (this.state.verificationData && this.state.verificationData.phone_no) : (this.state.verificationData && this.state.verificationData.email_id)}
                </h4>
                <Input
                    onChange={this.onchangeOtpField}
                    className={"mt-10 mr-10"}
                    placeholder={"1234"}
                />
                <div className="mt-10 d-flex">
                    <Button type={"primary"} disabled={!this.state.otpValue} onClick={this.confirmViaOtp}>
                        Submit
                    </Button>
                    <Button type={"link"}  onClick={this.resendOTP}>
                        Resend OTP
                    </Button>
                </div>
            </React.Fragment>
        );
    }

    verifyPanAdhaarModal = () => {
        return (
            <React.Fragment>
                <h4 className={"mt-10"}>
                    Validate PAN/Aadhaar using Signzy
                </h4>
                <span>Name: <b>{this.state.verificationData && this.state.verificationData.name}</b></span>
                <br/>
                <span>{this.state.selectedVerficationType == "pan" ? "PAN No." : "Aadhaar No."} : <b>{
                    this.state.selectedVerficationType == "pan" ? 
                        (this.state.verificationData && this.state.verificationData.pan_no) : 
                        this.state.selectedVerficationType == "adhaar" ? 
                            (this.state.verificationData && this.state.verificationData.aadhar_no)
                            :  (this.state.verificationData && this.state.verificationData.pan_no)
                }</b></span>
                <div className="mt-10 d-flex flex-row align-items-center">
                    <Button type={"primary"} onClick={this.verifyPanAdhaar}>
                        Yes
                    </Button>
                    <Button className={"ml-10"} onClick={this.closeVerficationModal}>
                        No
                    </Button>
                </div>
            </React.Fragment>
        );
    }

    renderVerificationModal = () => {
        let modalContent = null;
        if (["phone", "email"].includes(this.state.selectedVerficationType)) {
            if(this.state.verificationData) {
                if(this.state.selectedVerficationType === "phone" && this.state.verificationData.phone.verification_status === RCU_VERIFICATION_STATUS_TYPES.INITIATED) {
                    modalContent = this.sendOtpConfirmationModal();
                }
                else if(this.state.selectedVerficationType === "email" && this.state.verificationData.email.verification_status === RCU_VERIFICATION_STATUS_TYPES.INITIATED) {
                    modalContent = this.sendOtpConfirmationModal();
                }
                else if(this.state.selectedVerficationType === "phone" && this.state.verificationData.phone.verification_status === RCU_VERIFICATION_STATUS_TYPES.UNINITIATED) {
                    modalContent = this.triggerOtpModal();
                }
                else if(this.state.selectedVerficationType === "email" && this.state.verificationData.email.verification_status === RCU_VERIFICATION_STATUS_TYPES.UNINITIATED) {
                    modalContent = this.triggerOtpModal();
                }
            }
        }
        if(["adhaar", "pan" , "company_pan"].includes(this.state.selectedVerficationType)) {
            modalContent = this.verifyPanAdhaarModal();
        }
        return (
            <Modal
                visible={this.state.showVerificationModal}
                width={360}
                closable={true}
                onCancel={this.closeVerficationModal}
                destroyOnClose={true}
                footer={null}
            >
                {modalContent}
            </Modal>
        );
    }

    downloadRcuReport = () => {
        CompanyService.downloadRcuReport(this.props.caseId).then(({ data }) => {
            var blob = new Blob([data], { type: "application/pdf" });
            var elem = window.document.createElement("a");
            elem.href = window.URL.createObjectURL(blob);
            elem.download = `rcu-report-${this.props.caseId}.pdf`;
            document.body.appendChild(elem);
            elem.click();
            document.body.removeChild(elem);
        }).catch(() => {
            message.error("Failed to Download RCU Report");
        });
    }

    verifyApplicantDetails = (type, data ) => {
        this.setState({
            showVerificationModal: true,
            selectedVerficationType: type,
            verificationData: data,
        });
    }

    getCaseBankAccountDefaultApplicable = (_) => {
        if(this.state.caseBankAccounts && this.state.caseBankAccounts.length) {
            let account = this.state.caseBankAccounts.find(val => _.id == val.company_bank_account);
            if(account) {
                return account.is_applicable;
            }
        }
        return false;
    }

    getCaseApplicantDefaultBorrower = (_) => {
        if(this.state.modalToggleData && (this.state.modalToggleData.length || this.state.modalToggleData.size)) {
            let associate = this.state.modalToggleData.find(val => _.id == (val.company_associate && val.company_associate.id));
            if(associate) {
                return associate.is_main_borrower;
            }
            return null;
        }
        return null;
    }
    getCaseApplicantDefaultsignatory = (_) => {
        // console.log("caseAssociates is ",this .state.caseAssociates)
        if(this.state.modalToggleData && (this.state.modalToggleData.length || this.state.modalToggleData.size)) {
            let associate = this.state.modalToggleData.find(val => _.id == (val.company_associate && val.company_associate.id));
            if(associate) {
                return associate.is_authorized_signatory; 
            }
            return null;
        }
        return null;

    }

    toggleBankAccountModal = () => {
        this.setState({
            showBankAccountApplicableModal: !this.state.showBankAccountApplicableModal
        });
    }

    selectCaseAssociatesModal = () => {
        const { company } = this.props;
        return (
            <Modal
                visible={this.state.showApplicantModal}
                onOk={this.updateCaseApplicants}
                onCancel={this.closeApplicantModal}
                closable={true}
                destroyOnClose={false}
            >
                <div className={"p-10 w-100"}>
                    {company.associates && company.associates.map((_, k) => (
                        <div key={k} className={"mt-5 p-5 mb-5 d-flex justify-content-space-between"}>
                            <div className={"d-flex flex-column"}>
                                <span style={{fontWeight: "600"}}>
                                    {`${_.first_name || ""} ${_.last_name || ""}`}
                                </span>
                                <span>
                                    {_.phone || ""}
                                </span>
                                <span>
                                    {_.email || ""}
                                </span>
                            </div>
                            <div className={"d-flex flex-column"}>
                                <Select
                                    onSelect={this.onapplicant_idType.bind(null, _.id)}
                                    placeholder={"Type"}
                                    style={{
                                        width: "200px"
                                    }}
                                    defaultValue={this.getCaseAssociateDefaultValue(_)}
                                >
                                    {APPLICANT_TYPES.map((value, key) => (
                                        <Select.Option key={value} value={value}>
                                            {key}
                                        </Select.Option>
                                    )).toList().toArray()}
                                </Select>
                                <div className={"mt-10 d-flex justify-content-space-between"}>
                                    <span>
                                        {"Is Main Borrower?"}
                                    </span>
                                    <Switch
                                        defaultChecked={this.getCaseApplicantDefaultBorrower(_)}
                                        onChange={this.onChangeIsMainBrrower.bind(null, _.id)}
                                    />
                                </div>
                                 <div className={"mt-10 d-flex justify-content-space-between"}>
                                    <span>

                                        {"Is Authorized Signatory?"}
                                    </span>
                                 <Switch
                                    checked={this.getCaseApplicantDefaultsignatory(_)} 
                                    onChange={(val) => this.onChangeisauthorizedsignatory(_.id, val)}
                                    />
                                   
                                </div>
                            </div>
                        </div>
                    )).toList().toArray()}
                </div>
            </Modal>
        );
    }

    selectCaseBankAccountsModal = () => {
        const { company } = this.props;
        return (
            <Modal
                visible={this.state.showBankAccountApplicableModal}
                onOk={this.updateCaseBankAccounts}
                onCancel={this.toggleBankAccountModal}
                closable={true}
                destroyOnClose={true}
            >
                <div className={"w-100 p-5"}>
                    {company.bank_accounts && company.bank_accounts.map((_, k) => (
                        <div key={k} className={"mt-5 p-5 mb-5 d-flex justify-content-space-between"}>
                            <div className={"d-flex flex-column"}>
                                <span style={{fontWeight: "600"}}>
                                    {_.account_holder_name || ""}
                                </span>
                                <span>
                                    {_.account_number || ""}
                                </span>
                                <span>
                                    {_.bank_branch && _.bank_branch.name || ""}
                                </span>
                            </div>
                            <Switch
                                defaultChecked={this.getCaseBankAccountDefaultApplicable(_)}
                                onChange={this.onSelectIsBankAccountApplicable.bind(null, _.id)}
                            />
                        </div>
                    )).toList().toArray()}
                </div>
            </Modal>
        );
    }

    refreshAssociates = () => {
        this.props.fetchCompanyAssociatesV2(this.props.caseId)
    }

    renderCaseAdditionalDetails(permissionContext) {
        const {
            companyId,
            companyStatus,
            company,
            updateCompanyAssociates,
            updateCompanyAddress,
            updateCompanyBankAccounts,
        } = this.props;
        const onSelectApll = (val) => {
            this.setState({applicant_id:val});
        };
        const onbank_account_id = (val) => {
            this.setState({bank_account_id:val});
        };
        const current_case_task = this.props.current_case_task.toJS().current_case_task;
        const disabledEnachBtn = !current_case_task.find(_=>_.this_stage==11)
         && current_case_task.find(_=>_.this_stage==42)
        && this.props.user.toJS().groups.find(_=>_.id==10);
        const triggerEnach = () => {
            this.setState({loading: true});
            try {
                this.state.applicant_id && this.state.bank_account_id ? CompanyService.triggerEnach(this.state.applicant_id, this.state.bank_account_id, this.props.caseId).then(res=>{
                    if(res.status === 200){
                        this.getRegisteredNachDateFn(); 
                        message.success(res.data.status);
                        this.setState({loading:false});
                    }
                }) : message.error("Please fill all the fields").catch((err) => {
                    console.error(err);
                    this.setState({loading:false});
                    message.error(err);
                });
            } catch (e) {
                this.setState({loading:false});
                console.log(e);
            }
        };
        let caseAssociates = this.props.caseAssociates && List.isList(this.props.caseAssociates) &&  this.props.caseAssociates.filter(_ => [1,2].includes(_.type)).map(_ => Number(_.company_associate.id));
        if(!permissionContext.find((_, k) => k === "case_details_company_profile_view")) {
            if (this.state.loading) {
                return (
                    <div className="d-flex flex-column justify-content-center align-items-center p-10">
                        <Spin size={"large"}/>
                        <div>
                                Triggering eNACH, Please wait...
                        </div>
                    </div>
                );
            }
            return(<React.Fragment>
                {this.selectCaseAssociatesModal()}
                {this.selectCaseBankAccountsModal()}
                <Col span={14} className={"p-10"}>
                   {<AssociatesNewForm 
                        company={this.props.company}
                        recreditViewOnlyPermission={this.props.recreditViewOnlyPermission}
                        isUserAllowedToEdit={this.props.isUserAllowedToEdit}
                        associates ={this.props.companyNewAssociates ? this.props.companyNewAssociates :Map()}
                        status={this.props.companyNewAssociatesStatus}
                        caseId = {this.props.caseId}
                        companyId={companyId}
                        refreshAssociates={this.refreshAssociates}
                        update={updateCompanyAssociates}
                    />}
                    {/* <AssociatesAddTable
                        companyNewAssociates ={this.props.companyNewAssociates}
                        companyId={companyId}
                        company={this.props.company}
                        status={
                            companyStatus &&
                                    companyStatus.get("associatesStatus")
                        }
                        showSpocOnly={!!permissionContext.find((_, k) => k === "case_details_company_profile_view")}
                        associates={company.associates && company.associates.filter(_ => caseAssociates && caseAssociates.includes(Number(_.id)))}
                        deleteAssociateStatus={
                            this.props.deleteAssociateStatus
                        }
                        addresses={company.addresses.filter(_ => _.associate)}
                        update={updateCompanyAssociates}
                        caseId={this.props.caseId}
                        openCaseApplicantModal={this.openCaseApplicantModal}
                        isUserAllowedToEdit={this.props.isUserAllowedToEdit}
                        recreditViewOnlyPermission={this.props.recreditViewOnlyPermission}
                    /> */}   
                </Col>
                <Col span={10} className={"p-10"}>
                    <Row>
                        {/* <Col span={24} className={"mb-10"}>
                            {this.props.user.toJS().groups.find(_=>_.id==10)&& 
                            <Card className="d-flex flex-column justify-content-center" title={"Trigger Enach"}>
                                <div  className="d-flex flex-column">
                                    <div  className="d-flex justify-content-space-between">
                                        <div className="d-flex flex-column align-items-center">
                                            <p> Applicants<span style={{color:"red"}}>*</span> </p>
                                            <Select
                                                style={{
                                                    width: "150px"
                                                }}
                                                onSelect={onSelectApll}
                                                // value={
                                                //     this.state.applicants
                                                // }
                                                placeholder="Select Applicant"
                                            >
                                                {company && company.toJS().associates && Object.values(company.toJS().associates).length >0 && Object.values(company.toJS().associates).map(_ => (
                                                    <Select.Option key={_.id} value={_.id}>
                                                        {_.first_name} {_.last_name}
                                                    </Select.Option>
                                                ))}
                                            </Select>
                                        </div>
                                        <div className="d-flex flex-column align-items-center">
                                            <p>Bank Accounts<span style={{color:"red"}}>*</span> </p>
                                            <Select
                                                style={{
                                                    width: "150px"
                                                }}
                                                onSelect={onbank_account_id}
                                                placeholder="Select Bank Account"
                                            >
                                                {company && company.toJS().bank_accounts && Object.values(company.toJS().bank_accounts).length>0 && Object.values(company.toJS().bank_accounts).map(_ => (
                                                    <Select.Option key={_.id} value={_.id}>
                                                        {_.account_number}
                                                    </Select.Option>
                                                ))}
                                            </Select>
                                        </div>
                                        <div  className="d-flex flex-column align-items-center">
                                            <p> Action</p>
        
                                            <Button disabled={disabledEnachBtn} 
                                                type={"primary"}  size={"small"} onClick={triggerEnach}> Trigger Nach</Button>
                                        </div>
                                    </div>
                                    <div style={{margin:"10px 0"}}>
                                        {this.state.getRegisteredNachDate && this.state.getRegisteredNachDate.status ===1 ?
                                            <><span style={{fontWeight:"700"}}>Status </span>: eNACH successfully registered on {this.state.getRegisteredNachDate && this.state.getRegisteredNachDate.status_change_date && moment(this.state.getRegisteredNachDate.status_change_date).format("DD-MM-YYYY hh:mm:ss a")}</>
                                            : this.state.getRegisteredNachDate && this.state.getRegisteredNachDate.status ===3 ? 
                                           <> <span style={{fontWeight:"700"}}>Status </span>: eNACH failed on {this.state.getRegisteredNachDate && this.state.getRegisteredNachDate.status_change_date && moment(this.state.getRegisteredNachDate.status_change_date).format("DD-MM-YYYY hh:mm:ss a")}</> : null
                                        }
                                    </div>
                                </div>
                            </Card>}
                        </Col> */}
                        <Col span={24} className={"mb-10"}>
                            <Card title={"Case Associates"} extra={[
                                <Button type="link" key="update" disabled={this.props.recreditViewOnlyPermission} onClick={this.openCaseApplicantModal}>
                                    {"Update"}
                                </Button>
                            ]}>
                                {this.getCaseAssociatesTable()}
                            </Card>
                        </Col>
                    </Row>
                    <BankAccountAddList
                        companyId={companyId}
                        status={
                            companyStatus &&
                                    companyStatus.get("bankAccountsStatus")
                        }
                        isUserAllowedToEdit={this.props.isUserAllowedToEdit}
                        toggleBankAccountModal={this.toggleBankAccountModal}
                        bankAccounts={company.bank_accounts}
                        associates={company.associates}
                        update={updateCompanyBankAccounts}
                        applicableAccounts={this.state.caseBankAccounts && this.state.caseBankAccounts.map(_ => ({
                            company_bank_account: _.company_bank_account,
                            is_applicable: _.is_applicable

                        }))}
                        caseId={this.props.caseId}
                        recreditViewOnlyPermission={this.props.recreditViewOnlyPermission}
                    />
                    <Row>
                        <Col span={24} className={"mt-20"}>
                            {this.renderCaseTallyOutstanding(permissionContext)}
                        </Col>
                    </Row>
                   <Row>
                        <CaseBureauDetails {...this.props} hideCommercialData={true} />
                   </Row>
                </Col>
                <Col span={24}>
                    <Row>
                        <Col span={12} className={"p-10"}>
                            <AddressCard
                                companyId={companyId}
                                title={"Registered Address"}
                                type={"Registered"}
                                address={company.registered_address}
                                isUserAllowedToEdit={this.props.isUserAllowedToEdit}
                                optionalAddress={this.state.gstin_address}
                                optionalAddressLabel={"Select as per GSTIN"}
                                status={
                                    companyStatus &&
                                            companyStatus.get("addressesStatus")
                                }
                                update={updateCompanyAddress}
                                recreditViewOnlyPermission={this.props.recreditViewOnlyPermission}
                            />
                        </Col>
                        <Col span={12} className={"p-10"}>
                            <AddressCard
                                companyId={companyId}
                                title={"Operating Address"}
                                type={"Office"}
                                permissionContext={permissionContext}
                                isUserAllowedToEdit={this.props.isUserAllowedToEdit}
                                optionalAddress={company.registered_address}
                                optionalAddressLabel={"Same as Registered"}
                                address={company.operating_address}
                                status={
                                    companyStatus &&
                                            companyStatus.get("addressesStatus")
                                }
                                update={updateCompanyAddress}
                                recreditViewOnlyPermission={this.props.recreditViewOnlyPermission}
                            />
                        </Col>
                    </Row>
                </Col>
                <Col span={24}>
                    <ApplicantVerificationTable
                        associates={this.props.applicantVerificationList && this.props.applicantVerificationList.filter(_ => caseAssociates && caseAssociates.includes(Number(_.associate_id)))}
                        verifyDetails={this.verifyApplicantDetails}
                        loading={this.props.applicantVerificationStatus == "FETCHING"}
                        reloadData={this.refreshVerificationList}
                        downloadRcuReport={this.downloadRcuReport}
                        documents={this.props.companyDocuments}
                        fetchAssociateList={this.fetchAssociateList}
                    />
                    {this.renderVerificationModal()}
                </Col>
                {this.props.applicantVerificationList 
                && this.props.applicantVerificationList.filter(_ => _.company_pan && Object.keys(_.company_pan).length).size
                    ? <Col span={24}>
                        <EntityVerificationTable
                            associates={this.props.applicantVerificationList && this.props.applicantVerificationList.filter(_ => _.company_pan && Object.keys(_.company_pan).length)}
                            verifyDetails={this.verifyApplicantDetails}
                            loading={this.props.applicantVerificationStatus == "FETCHING"}
                            reloadData={this.refreshVerificationList}
                            downloadRcuReport={this.downloadRcuReport}
                            documents={this.props.companyDocuments}
                            fetchAssociateList={this.fetchAssociateList}
                        />
                        {this.renderVerificationModal()}
                    </Col> : null}
            </React.Fragment>);
        }   
        return null;
    } 

    /**
     * Applicant level data availability check, visible on the credit appraisal stage.
     * Data comes from the `associate_parameter_checkers` key of the case-detail-fields API.
     */
    renderApplicantParameterChecker() {
        // Credit Appraisal stage, and only when the case is assigned to the logged in user.
        if (
            !CREDIT_APPRAISAL_STAGE_IDS.includes(Number(this.props.stageId)) ||
            !this.props.isUserAllowedToEdit
        ) {
            return null;
        }
        const applicants =
            (this.props.caseDetailFields &&
                this.props.caseDetailFields.get("associate_parameter_checkers")) ||
            [];
        const pendingCount = applicants.reduce(
            (count, applicant) =>
                count + (applicant.checks || []).filter(_ => !_.present).length,
            0
        );
        const loading = [STATE_STATUS.FETCHING, STATE_STATUS.UPDATING].includes(
            this.props.caseDetailFieldsStatus
        );
        const accent = pendingCount ? "#faad14" : "#52c41a";
        return (
            <div className={"p-10"}>
                <Row
                    type={"flex"}
                    justify={"space-between"}
                    align={"middle"}
                    style={{
                        background: "#fff",
                        border: "1px solid #e8e8e8",
                        borderLeft: `3px solid ${accent}`,
                        borderRadius: 4,
                        padding: "10px 16px"
                    }}
                >
                    <Col>
                        <div className={"d-flex align-items-center"}>
                            <Icon
                                type={pendingCount ? "exclamation-circle" : "check-circle"}
                                theme={"filled"}
                                style={{ color: accent, fontSize: 18, marginRight: 10 }}
                            />
                            <div>
                                <div style={{ fontWeight: 600 }}>Applicant Details Check</div>
                                <div style={{ color: "#8c8c8c", fontSize: 12 }}>
                                    {pendingCount
                                        ? `${pendingCount} detail(s) pending across ${applicants.length} applicant(s)`
                                        : "All applicant details captured"}
                                </div>
                            </div>
                        </div>
                    </Col>
                    <Col>
                        <Badge count={pendingCount} offset={[-4, 2]}>
                            <Button
                                type={"primary"}
                                ghost={!pendingCount}
                                icon={"profile"}
                                loading={loading}
                                onClick={() =>
                                    this.setState({ showApplicantParameterModal: true })
                                }
                            >
                                View Details
                            </Button>
                        </Badge>
                    </Col>
                </Row>
                <ApplicantParameterCheckerModal
                    visible={this.state.showApplicantParameterModal}
                    onCancel={() => this.setState({ showApplicantParameterModal: false })}
                    applicants={applicants}
                    loading={loading}
                />
            </div>
        );
    }

    render() {
        const {
            companyStatus,
            permissionContext
        } = this.props;
        if (
            !companyStatus ||
            ![STATE_STATUS.FETCHED, STATE_STATUS.UPDATED].includes(companyStatus.get("companyStatus"))
        ) {
            return "FETCHING";
        }
        return (
            <Row className={"p-5"}>
                <Col span={24}>{this.renderApplicantParameterChecker()}</Col>
                {this.renderSupplyChainView(permissionContext)}
                {this.renderProfileForm(permissionContext)}
                {this.renderSalesAnalysis(permissionContext)}
                {this.renderSpocForm(permissionContext)}
                {this.renderCaseAdditionalDetails(permissionContext)}
            </Row>
        );
    }
}
/**
 *  Case Summary Properties
 */
CaseSummary.propTypes = {
    caseDetail: PropTypes.instanceOf(CaseDetailRecord),
    caseDetailStatus: PropTypes.string,
    companyId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    company: PropTypes.object,
    companyStatus: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    caseId: PropTypes.number,
    financials: PropTypes.object, // SupplyChainFinancials Data,
    financialsStatus: PropTypes.string, // SupplyChainFinancials Load Status,
    supplyChainStatus: PropTypes.string, // SupplyChainFinancials Load Status,
    supplyChain: PropTypes.object, // SupplyChainFinancials Data
    fetchCaseSupplyChainDetails: PropTypes.func,
    fetchCaseSupplyChainFinancials: PropTypes.func,
    updateCaseDetail: PropTypes.func,
    updateCaseSupplyChainDetails: PropTypes.func,
    updateCompanyAssociates: PropTypes.func,
    updateCompanyBankAccounts: PropTypes.func,
    updateCompanyAddresses: PropTypes.func,
    updateCompanyAddress: PropTypes.func,
    permissionContext: PropTypes.object,
    updateCompanyProfile: PropTypes.func,
    isUserAllowedToEdit: PropTypes.bool,
    addCaseAssociates: PropTypes.func,
    deleteCaseAssociates: PropTypes.func,
    caseAssociates: PropTypes.array,
    caseAssociatesStatus: PropTypes.string,
    fetchAssociatesVerificationList: PropTypes.func,
    applicantVerificationList: PropTypes.object,
    applicantVerificationStatus: PropTypes.string,
    fetchCompanyDocuments: PropTypes.func,
    files: PropTypes.object,
    fetchCaseDocuments: PropTypes.func,
    documents: PropTypes.object,
    current_case_task: PropTypes.object,
    user: PropTypes.object,
    addCaseBankAccounts: PropTypes.func,
    deleteCaseBankAccounts: PropTypes.func,
    caseBankAccounts: PropTypes.array,
    caseBankAccountsStatus: PropTypes.string,
    documentsStatus: PropTypes.string,
    createCibilRequest: PropTypes.func,
    companyDocuments: PropTypes.array,
    fetchCaseAssociates : PropTypes.func,
    deleteAssociateStatus : PropTypes.string,
    updateCaseAssociateStatus: PropTypes.func,
    fetchCompanyProfile: PropTypes.func,
    addCaseCompanyAssociates: PropTypes.func,
    recreditViewOnlyPermission: PropTypes.bool,
    stageId: PropTypes.number,
    caseDetailFields: PropTypes.object,
    caseDetailFieldsStatus: PropTypes.string,
    fetchCaseDetailFields: PropTypes.func,
};
/**
 *
 * @param {*} state
 * @param {*} props
 */
const mapStateToProps = (state, props) => {
    // Read the record directly - do NOT gate this on status === "FETCHED".
    // `a && (status === "FETCHED") && data` returns the *boolean* produced by the
    // comparison whenever status is anything else, so a refetch handed the render
    // body `false` instead of a record and `false.toJS()` blanked the tab.
    // Same shape as the fix in case-details-tabs/index.js: the reducer's
    // stale-while-revalidate keeps `data` populated across a refetch, and
    // isLoading() deliberately leaves this tab mounted in that window - so the
    // previous good record is exactly what should stay on screen.
    const current_case_task = state.caseDetails
        ? state.caseDetails.getIn([Number(props.caseId), "data"])
        : null;
    return{
        company: state.companies.getIn([props.companyId, "data"]),
        companyStatus: state.companies.getIn([props.companyId, "status"]),
        caseDetail: state.caseDetails.getIn([props.caseId, "data"]),
        caseDetailStatus: state.caseDetails.getIn([props.caseId, "status"]),
        deleteAssociateStatus : state.caseDetails.getIn([props.caseId, "caseAssociates", "deleteAssociateStatus"]),
        financials: state.supplyChain.getIn(["financials", props.caseId, "data"]),
        financialsStatus: state.supplyChain.getIn([
            "financials",
            props.caseId,
            "status"
        ]),
        supplyChain: state.supplyChain.getIn(["records", props.caseId, "data"]),
        supplyChainStatus: state.supplyChain.getIn([
            "records",
            props.caseId,
            "status"
        ]),
        current_case_task: current_case_task,
        caseAssociatesStatus: state.caseDetails.getIn([Number(props.caseId), "caseAssociates", "status"]),
        caseAssociates: state.caseDetails.getIn([props.caseId, "caseAssociates", "data"]),
        applicantVerificationList: state.applicantVerificationList.getIn(["companies", props.companyId, "data"]),
        applicantVerificationStatus: state.applicantVerificationList.getIn(["companies", props.companyId, "status"]),
        files: state.documents.getIn(["company_documents", props.companyId]),
        documents: state.documents.getIn(["case_documents", props.caseId]),
        caseBankAccountsStatus: state.caseDetails.getIn([Number(props.caseId), "caseBankAccounts", "status"]),
        caseBankAccounts: state.caseDetails.getIn([props.caseId, "caseBankAccounts", "data"]),
        documentsStatus: state.documents.getIn(["company_documents", props.companyId, "status"]),
        user: state.user.get("data"),
        companyDocuments: state.documents
            .getIn(["company_documents", props.companyId, "data"], Map({}))
            .map(_ => _.get("data"))
            .filter(_ => _.is_active),
        companyNewAssociates : state.companies.get('associatesListV2'),
        companyNewAssociatesStatus : state.companies.get('associatesListV2Status'),
        caseDetailFields: state.caseDetails.getIn([props.caseId, "caseDetailFields", "data"]),
        caseDetailFieldsStatus: state.caseDetails.getIn([props.caseId, "caseDetailFields", "status"], STATE_STATUS.UNFETCHED)

    };};

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            fetchCaseSupplyChainDetails,
            fetchCaseSupplyChainFinancials,
            updateCaseDetail,
            updateCaseSupplyChainDetails,
            updateCompanyAssociates,
            updateCompanyAddresses,
            updateCompanyAddress,
            updateCompanyBankAccounts,
            updateCompanyProfile,
            addCaseAssociates,
            deleteCaseAssociates,
            fetchCompanyDocuments,
            fetchAssociatesVerificationList,
            fetchCaseDocuments,
            addCaseBankAccounts,
            deleteCaseBankAccounts,
            createCibilRequest,
            fetchCaseAssociates,
            fetchCompanyProfile,
            updateCaseAssociateStatus,
            addCaseCompanyAssociates,
            fetchCompanyAssociatesV2,
            fetchCaseDetailFields
        },
        dispatch
    );

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(CaseSummary);
